import { render, staticRenderFns } from "./DocumentsManagement.vue?vue&type=template&id=f0e2192c&scoped=true"
import script from "./DocumentsManagement.vue?vue&type=script&lang=js"
export * from "./DocumentsManagement.vue?vue&type=script&lang=js"
import style0 from "./DocumentsManagement.vue?vue&type=style&index=0&id=f0e2192c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e2192c",
  null
  
)

export default component.exports